export const SubscribeEmail = () => {
  return `mutation Mutation($data: EmailSubscriptionInput!, $status: PublicationStatus) {
  createEmailSubscription(data: $data, status: $status) {
    documentId
    email
    createdAt
    updatedAt
    publishedAt
  }
}`;
};
